if (!customElements.get('product-card-data-add')) {
  customElements.define(
    'product-card-data-add',
    class ProductCardDataAdd extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const addButton = event.target.closest('[data-card-add]');
        if (!addButton || !this.contains(addButton)) return;
        event.preventDefault();

        if (addButton.classList.contains('loading') || addButton.getAttribute('aria-disabled') === 'true') return;

        this.addToCart(addButton);
      }

      async addToCart(addButton) {
        const variantId = Number(addButton.dataset.variantId);
        const productUrl = addButton.dataset.productUrl;
        const localeRoot = window.Shopify?.routes?.root || '/';
        const cartAddUrl = `${localeRoot}cart/add.js`;
        if (!variantId) {
          if (productUrl) window.location = productUrl;
          return;
        }

        addButton.classList.add('loading');
        addButton.setAttribute('aria-disabled', 'true');
        const spinner = addButton.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        try {
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const payload = {
            items: [{ id: variantId, quantity: 1 }],
          };

          if (cart && typeof cart.getSectionsToRender === 'function') {
            payload.sections = cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = `${window.location.pathname}${window.location.search}`;
          }

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();

          if (data.status) {
            this.showSoldOutState(addButton);
            return;
          }

          if (
            data.product_id &&
            Array.isArray(window.cartItems) &&
            window.cartItems.includes(`${data.product_id}`) === false
          ) {
            window.cartItems = [...window.cartItems, `${data.product_id}`];
          }

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          console.error('Product card add-to-cart error', error);
          if (productUrl) window.location = productUrl;
        } finally {
          addButton.classList.remove('loading');
          if (!addButton.hasAttribute('disabled')) addButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      showSoldOutState(addButton) {
        const soldOutMessage = addButton.querySelector('.sold-out-message');
        const labelsToHide = addButton.querySelectorAll('span.flex, .card-product-v2__btn-label, .card-product-v2__btn-sep, .card-product-v2__btn-price');

        addButton.setAttribute('disabled', 'disabled');
        addButton.removeAttribute('aria-disabled');
        labelsToHide.forEach((label) => label.classList.add('hidden'));
        if (soldOutMessage) soldOutMessage.classList.remove('hidden');
      }
    },
  );
}
